module.exports = __webpack_public_path__ + "img/team.44f907f2.png";